import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import {
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export default function IndividualJSON() {

    const navigate = useNavigate();

    const [loading, setLoading] =
        useState(true);

    const [items, setItems] =
        useState([]);

    const [newJson, setNewJson] =
        useState("");

    /* ---------------- FETCH ---------------- */
    useEffect(() => {

        fetchItems();

    }, []);

    const fetchItems = async () => {

        try {

            const snap = await getDoc(
                doc(
                    db,
                    "individual",
                    "allData"
                )
            );

            if (snap.exists()) {

                setItems(
                    snap.data().items || []
                );
            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    /* ---------------- SAVE ---------------- */
    const saveItems = async (
        updatedItems
    ) => {

        try {

            await setDoc(
                doc(
                    db,
                    "individual",
                    "allData"
                ),
                {
                    items: updatedItems,
                }
            );

            setItems(updatedItems);

        } catch (err) {

            console.error(err);

            alert("Failed ❌");
        }
    };

    /* ---------------- ADD ---------------- */
    const handleAddItem = async () => {

        try {

            if (!newJson.trim()) {

                return alert(
                    "Paste JSON"
                );
            }

            const parsed =
                JSON.parse(newJson);

            if (!parsed.title) {

                return alert(
                    "Title missing"
                );
            }

            if (!parsed.type) {

                return alert(
                    "Type missing"
                );
            }

            /* AUTO ID */
            if (!parsed.id) {

                parsed.id =
                    parsed.title
                        .toLowerCase()
                        .replace(
                            /\s+/g,
                            "-"
                        );
            }

            const alreadyExists =
                items.some(
                    (item) =>
                        item.id ===
                        parsed.id
                );

            if (alreadyExists) {

                return alert(
                    "ID already exists"
                );
            }

            /* FINAL STRUCTURE */
            const finalItem = {

                type:
                    parsed.type ||
                    "tool",

                title:
                    parsed.title ||
                    "",

                id:
                    parsed.id ||
                    "",

                category:
                    parsed.category ||
                    "",

                icon:
                    parsed.icon ||
                    "",

                logo:
                    parsed.logo ||
                    "",

                banner:
                    parsed.banner ||
                    "",

                shortDescription:
                    parsed.shortDescription ||
                    "",

                levels:
                    parsed.levels ||
                    [],

                curriculum:
                    parsed.curriculum ||
                    [],

                projects:
                    parsed.projects ||
                    [],

                outcomes:
                    parsed.outcomes ||
                    [],

                seo: {

                    seoTitle:
                        parsed.seo
                            ?.seoTitle ||
                        "",

                    seoDescription:
                        parsed.seo
                            ?.seoDescription ||
                        "",

                    seoKeywords:
                        parsed.seo
                            ?.seoKeywords ||
                        [],
                },
            };

            const updated = [
                ...items,
                finalItem,
            ];

            await saveItems(updated);

            setNewJson("");

            alert("Added ✅");

        } catch (err) {

            console.error(err);

            alert(
                "Invalid JSON ❌"
            );
        }
    };

    /* ---------------- DELETE ---------------- */
    const handleDelete = async (
        index
    ) => {

        const confirmDelete =
            window.confirm(
                "Delete this item?"
            );

        if (!confirmDelete) return;

        const updated =
            items.filter(
                (_, i) =>
                    i !== index
            );

        await saveItems(updated);
    };

    if (loading) {

        return (
            <div className="text-white">
                Loading...
            </div>
        );
    }

    return (

        <div className="text-white">

            {/* HEADER */}
            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-3xl font-bold text-orange-500">
                        Technologies
                    </h1>

                    <p className="text-slate-400 mt-1">
                        Manage languages,
                        frameworks,
                        software &
                        tools
                    </p>

                </div>

                <button
                    onClick={() =>
                        navigate(-1)
                    }
                    className="bg-white/10 hover:bg-white/20 transition-all px-4 py-2 rounded-lg"
                >
                    Back
                </button>

            </div>

            {/* ADD JSON */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <div className="mb-5">

                    <h2 className="text-xl font-semibold">
                        Paste JSON
                    </h2>

                    <p className="text-slate-400 text-sm mt-1">
                        Add language,
                        framework,
                        software or tool
                    </p>

                </div>

                <textarea
                    rows={18}
                    value={newJson}
                    onChange={(e) =>
                        setNewJson(
                            e.target
                                .value
                        )
                    }
                    placeholder='Paste JSON here...'
                    className="w-full p-4 rounded-2xl bg-black/40 border border-white/20 font-mono text-sm"
                />

                <button
                    onClick={
                        handleAddItem
                    }
                    className="mt-5 bg-orange-500 hover:bg-orange-600 transition-all px-6 py-3 rounded-xl font-medium"
                >
                    Add Item
                </button>

            </div>

            {/* ITEMS */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">

                {items.map(
                    (
                        item,
                        index
                    ) => (

                        <div
                            key={index}
                            className="bg-white/5 border border-white/10 rounded-2xl p-5 hover:border-orange-500/40 transition-all"
                        >

                            {/* TYPE */}
                            <div className="mb-4">

                                <span className="inline-block bg-orange-500/20 text-orange-400 text-xs px-3 py-1 rounded-full uppercase tracking-wider">

                                    {
                                        item.type
                                    }

                                </span>

                            </div>

                            {/* TITLE */}
                            <h3 className="text-xl font-semibold">

                                {item.title}

                            </h3>

                            {/* ID */}
                            <p className="text-sm text-slate-400 mt-2">

                                ID:
                                {" "}
                                {item.id}

                            </p>

                            {/* CATEGORY */}
                            <p className="text-sm text-slate-500 mt-1">

                                {
                                    item.category
                                }

                            </p>

                            {/* BUTTONS */}
                            <div className="flex gap-3 mt-5">

                                <button
                                    onClick={() =>
                                        navigate(
                                            `/dashboard/individual-view?id=${item.id}`
                                        )
                                    }
                                    className="flex-1 bg-orange-500 hover:bg-orange-600 transition-all px-4 py-2 rounded-lg text-sm"
                                >
                                    View
                                </button>

                                <button
                                    onClick={() =>
                                        handleDelete(
                                            index
                                        )
                                    }
                                    className="flex-1 bg-red-600 hover:bg-red-700 transition-all px-4 py-2 rounded-lg text-sm"
                                >
                                    Delete
                                </button>

                            </div>

                        </div>

                    )
                )}

            </div>

            {/* EMPTY */}
            {items.length ===
                0 && (

                    <div className="bg-white/5 border border-dashed border-white/10 rounded-2xl p-10 text-center text-slate-400 mt-8">

                        No items found

                    </div>

                )}

        </div>
    );
}